import { callsRequests } from '../requests/calls.request';
import { createApiThunk } from '../utils/api-thunk';

export const getCalls = createApiThunk(callsRequests.getCalls);

